import { TEST_HUB_URL } from '@/constants/constants';
import { Station } from '@/types';
import { apiFetch } from '@/utils/apiWrapper';

const stationsUrl = `${TEST_HUB_URL}station`;
export const getStationByOutlet = async (outletId: string) => {
  try {
    const res = await apiFetch(`${stationsUrl}/get-stations-by-outlet/${outletId}`);
    if (res?.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    throw new Error('Error getting stations by outlet');
  }
};

export const createStation = async (outletId: string, newStation: Partial<Station>) => {
  try {
    const res = await apiFetch(`${stationsUrl}/${outletId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newStation),
    });
    if (res?.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    throw new Error('Error creating station');
  }
};

export const deleteStation = async (id: string) => {
  try {
    const res = await apiFetch(`${stationsUrl}/${id}`, {
      method: 'DELETE',
    });
    if (res?.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    throw new Error('Error deleting station');
  }
};
